import { useLocation } from "wouter";
import { ArrowLeft } from "lucide-react";
import { BottomNav } from "@/components/BottomNav";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQ_ITEMS = [
  {
    id: "what-is-razzy",
    question: "What is the Razzy?",
    answer:
      "The Razzy is your permanent golf betting record and competitive profile. It digitizes the history, the rivalries, and the financial swings so you always know exactly where you stand after the round is over.",
  },
  {
    id: "press-win-pct",
    question: "Why do we track Press Win %?",
    answer:
      "Anyone can win the original bet, but the real pressure happens when the stakes double. Press Win % isolates how you perform when your back is against the wall. It separates the clutch players from the rest.",
  },
  {
    id: "stroke-utilization",
    question: 'What is "Stroke Utilization"?',
    answer:
      "This is the ultimate truth-teller. It breaks down your historical win rate on holes where you receive a stroke versus holes where you play straight up. It provides total transparency into how you use your handicap strokes during a match.",
  },
  {
    id: "what-is-frequent-foe",
    question: "What is a Frequent Foe?",
    answer:
      "Your Frequent Foe is the opponent or rivalry you face most often in the app. It helps turn repeated matchups into a real competitive record instead of just a collection of isolated rounds.",
  },
  {
    id: "why-frequent-foes",
    question: 'Why do you highlight "Frequent Foes"?',
    answer:
      "Golf is built on rivalries. We track the opponents you face most often and show your lifetime net result against them, so next time you step onto the first tee, there is no debating who has the upper hand.",
  },
  {
    id: "lifetime-net",
    question: 'How is my "Lifetime Net" calculated?',
    answer:
      "Your Lifetime Net is the sum of every finalized bet, press, and settlement across all formats recorded in the app. It is your true bottom line as a competitive golfer.",
  },
  {
    id: "stat-filters",
    question: "Are all stats filtered the same way?",
    answer:
      "Not always. Some ledger and profile stats respond to the selected time filter, while others are shown as lifetime metrics. We label these clearly so you always know what time window you are viewing.",
  },
];

function handleBack() {
  if (window.history.length > 1) {
    window.history.back();
  } else {
    window.location.href = "/ledger";
  }
}

export default function RazzyFaq() {
  return (
    <div className="min-h-screen bg-gray-50 pb-24" data-testid="page-razzy-faq">
      <div className="bg-[#064E3B] px-4 pt-12 pb-6">
        <button
          onClick={handleBack}
          className="flex items-center gap-1.5 text-[#FACC15] text-sm font-medium mb-4 active:opacity-70"
          data-testid="button-back"
        >
          <ArrowLeft className="w-4 h-4" />
          Back
        </button>
        <h1 className="text-xl font-bold text-white" data-testid="text-faq-title">
          Razzy FAQ
        </h1>
        <p className="text-sm text-emerald-200 mt-1">
          Everything you need to know about your stats
        </p>
      </div>

      <div className="px-4 py-4">
        <Accordion type="multiple" className="space-y-2.5">
          {FAQ_ITEMS.map((item) => (
            <AccordionItem
              key={item.id}
              value={item.id}
              className="bg-white rounded-xl border border-gray-100 shadow-sm px-4 overflow-hidden"
              data-testid={`faq-item-${item.id}`}
            >
              <AccordionTrigger className="text-left text-sm font-semibold text-gray-900 py-4 hover:no-underline">
                {item.question}
              </AccordionTrigger>
              <AccordionContent className="text-sm text-gray-600 leading-relaxed pb-4">
                {item.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>

      <BottomNav />
    </div>
  );
}
